import { connect } from "react-redux";
import RunbookOverview from "./RunbookOverview";
import {
  getRunbookDetailRequest,
  startRunbookRequest,
  stopRunbookRequest,
} from "../../../store/actions/runbooks.actions";
import {
  runbookDetail,
  runbookDetailLoading,
  runbookLoading,
} from "../../../store/selectors/runbooks.selector";

const mapStateToProps = (state) => ({
  detail: runbookDetail(state),
  detailLoading: runbookDetailLoading(state),
  saving: runbookLoading(state),
});

const mapDispatchToProps = {
  getRunbookDetailRequest,
  startRunbookRequest,
  stopRunbookRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RunbookOverview);
